import { InputHTMLAttributes } from "react";
import type { FieldError, UseFormRegisterReturn } from "react-hook-form";

import { FormField } from "@/components/form/FormField";

export function InputField({
  id,
  label,
  error,
  type = "text",
  register,
  ...props
}: InputHTMLAttributes<HTMLInputElement> & {
  id: string;
  label: string;
  error: FieldError["message"] | null;
  register: UseFormRegisterReturn | null;
}) {
  return (
    <FormField id={id} label={label} error={error} register={register}>
      <input
        type={type}
        id={id}
        className="w-full rounded-md border px-3 py-2"
        {...props}
      />
    </FormField>
  );
}
